import { render, staticRenderFns } from "./SupplierActionLogs.vue?vue&type=template&id=1ed48322&scoped=true&"
import script from "./SupplierActionLogs.vue?vue&type=script&lang=ts&"
export * from "./SupplierActionLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed48322",
  null
  
)

export default component.exports